'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const DEFAULT_CHAT_CONTEXT = {
  openOnLoad: false,
  chatOpen: false,
  hadChatInteraction: false,
  currentScrollTop: 0,
  chatExists: false
};
const ChatContext = /*#__PURE__*/React.createContext({
  state: DEFAULT_CHAT_CONTEXT,
  update: () => {}
});
const useChatUIState = () => React.useContext(ChatContext);
const ChatProvider = ({
  initialState,
  children
}) => {
  const [initialChatState, setInitialState] = React.useState(initialState);
  const update = React.useCallback(next => {
    setInitialState(next);
  }, []);
  const chatContextState = {
    ...DEFAULT_CHAT_CONTEXT,
    ...initialChatState
  };
  return /*#__PURE__*/React__default["default"].createElement(ChatContext.Provider, {
    value: {
      state: chatContextState,
      update
    }
  }, children);
};

exports.ChatProvider = ChatProvider;
exports.DEFAULT_CHAT_CONTEXT = DEFAULT_CHAT_CONTEXT;
exports["default"] = useChatUIState;
